import API from './const.js';
import useVahakHttpClient from '../hooks/useVahakHttpClient.js';
import { useVahakMutationQuery } from '../hooks/useVahakQueryClient.js';
import { QueryNames } from './hooks/queryNames.js';

function useDeactivateLorry() {
    const { POST } = useVahakHttpClient();
    const deactivateLorry = ({ lorryId }) => {
        const payload = { lorry_id: lorryId };
        return POST(API.DEACTIVATE_LORRY_BY_ID, payload);
    };
    return useVahakMutationQuery(QueryNames.userLorries.deactivateLorry, deactivateLorry);
}
const useDeactivateLoad = () => {
    const { POST } = useVahakHttpClient();
    const deactivateLoad = (data) => {
        const requestBody = {
            id: data.loadId,
            user_feedback: data.userFeedback
        };
        return POST(API.DEACTIVATE_LOAD_BY_ID, Object.assign({}, requestBody));
    };
    return useVahakMutationQuery(QueryNames.userLoads.deactivateLoadById, deactivateLoad);
};

export { useDeactivateLoad, useDeactivateLorry };
//# sourceMappingURL=deactivateLoadLorry.service.js.map
